import * as React from "react";
const SvgIcUpload = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7 8.5v6h6v-6h4l-7-7-7 7h4Zm3-4.2 2.2 2.2H11v6H9v-6H7.8L10 4.3Zm7 12.2H3v2h14v-2Z" /></svg>;
export default SvgIcUpload;